import { useQuery } from "@tanstack/react-query";

import { fetchDepartments } from "./api";
import { departmentQueryKey } from "./key";
import { mapDepartmentsToOptions } from "./selector";
import type { DepartmentItem } from "./type";

export const useDepartments = (searchText: string, excludeIds: string[] = []) =>
  useQuery({
    queryKey: departmentQueryKey.list(searchText, excludeIds),
    queryFn: () => fetchDepartments(searchText, excludeIds),
    select: (data: DepartmentItem[]) => mapDepartmentsToOptions(data),
    initialData: [],
  });
